export function CurrencySwitcherApp() {
  return {
    isSwitcherOpened: false,
    selectedLanguageIsoCode: '',
    toggleSwitcher() {
      this.isSwitcherOpened = !this.isSwitcherOpened;
    },
    closeSwitcher(event) {
      const isInsideSwitcher =
        this.$refs.currencySwitcher.contains(event.target) ||
        this.$refs.currencySwitcher === event.target;

      if (isInsideSwitcher) return;

      this.isSwitcherOpened = false;
    },
    selectLanguage(languageIsoCode) {
      this.selectedLanguageIsoCode = languageIsoCode;
    },
    handleOutsideClick(event) {
      this.closeSwitcher(event);
    },
    mountCurrencySwitcher() {
      document.addEventListener('click', this.handleOutsideClick);
    },
    unmountCurrencySwitcher() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
  };
}
